"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const ExpandMoreIconStyled = (0, _styles.styled)(props => {
  return /*#__PURE__*/_react.default.createElement(_ExpandMore.default, props);
})(_ref => {
  let {
    theme,
    expand
  } = _ref;
  return {
    transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  };
});

/**
 * Component to load content asynchronously
 *
 * @visibleName Expand More Button
 * @author Eric Shoemaker
*/
const ExpandMore = props => {
  const {
    expand = false,
    label,
    ...other
  } = props;
  return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    "aria-expanded": expand,
    "aria-label": expand ? "show less" : "show more",
    endIcon: /*#__PURE__*/_react.default.createElement(ExpandMoreIconStyled, {
      expand: expand ? 1 : 0
    })
  }, other), label);
};

// Define propTypes;
ExpandMore.propTypes = {
  /** Boolean to initialize open/closed beginning state (Default Value: false) */
  expand: _propTypes.default.bool,
  /** Button Label */
  label: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = ExpandMore;